
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/tracking-status-updates",
      function () {
        return require("private-next-pages/en/ai/tracking-status-updates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/tracking-status-updates"])
      });
    }
  